/**
 * Defines the maximum price acceptable to pay for **orders with tax**.
 */
export const maxOnlinePrice = 50_000;
